import { targetMoistureBagSpecs } from '@/modules/mixing/hooks';
import styles from './index.module.sass';

export const ResultCard = ({
  data,
  targetMoistureData,
  expertMode,
}: {
  data: any;
  targetMoistureData: targetMoistureBagSpecs;
  expertMode: boolean;
}) => {
  return (
    <>
      <div className={styles.input}>
        <span className={styles.label}>вес</span>
        <span className={styles.value}>
          {isNaN(+data.weight) ? '0' : +data?.weight.toFixed(2)}
        </span>
        <span className={styles.postfix}>т</span>
        {expertMode && (
          <span
            className={styles.subValue}
            style={{
              color:
                targetMoistureData.weightGain > 0
                  ? 'rgb(0, 126, 60)'
                  : 'rgb(231, 58, 66)',
            }}
          >
            {' '}
            {isNaN(targetMoistureData.weightGain) ? '0 т' : targetMoistureData.weightGain > 0
              ? `+${targetMoistureData.weightGain} т`
              : `${targetMoistureData.weightGain} т`}
              <span className={styles.sublabel}>{ +targetMoistureData.weightGain > 0 ? 'прибавка веса' : 'потеря веса'}</span>
          </span>
        )}
      </div>
      <div className={styles.input}>
        <span className={styles.label}>влажность</span>
        <span className={styles.value}>
          {isNaN(data.humidity) ? '0' : +data?.humidity}
        </span>
        <span className={styles.postfix}>%</span>
        {expertMode && (
          <span className={styles.subValue} style={{
            color:
              targetMoistureData.moistureCoeff > 0
                ? 'rgb(0, 126, 60)'
                : 'rgb(231, 58, 66)',
          }}>
            {isNaN(targetMoistureData.weightGain) ? '0 %' : targetMoistureData.moistureCoeff > 0
              ? `+${targetMoistureData.moistureCoeff} %`
              : `${targetMoistureData.moistureCoeff} %`}
              <span className={styles.sublabel}>{+targetMoistureData.moistureCoeff > 0 ? 'величина увлажнения' : 'величина усушки'}</span>
          </span>
        )}
      </div>
      <div className={styles.input}>
        <span className={styles.label}>клейковина</span>
        <span className={styles.value}>{isNaN(data.gluten) ? '0' : +data?.gluten}</span>
        <span className={styles.postfix}>%</span>
        {/* <span className={styles.subValue}>+9.70 т</span> */}
      </div>
      <div className={styles.input}>
        <span className={styles.label}>ИДК</span>
        <span className={styles.value}>{isNaN(data.idk) ? '0' : +data?.idk}</span>
        <span className={styles.postfix}>ед</span>
      </div>
      <div className={styles.input}>
        <span className={styles.label}>клоп</span>
        <span className={styles.value}>{isNaN(data.bug) ? '0' : +data?.bug}</span>
        <span className={styles.postfix}>%</span>
      </div>
      <div className={styles.input}>
        <span className={styles.label}>протеин</span>
        <span className={styles.value}>
          {isNaN(data.protein) ? '0' : +data?.protein}
        </span>
        <span className={styles.postfix}>%</span>
      </div>
      <div className={styles.input}>
        <span className={styles.label}>число падения</span>
        <span className={styles.value}>{isNaN(data.cp) ? '0' : +data.cp}</span>
        <span className={styles.postfix}>сек</span>
      </div>
      <div className={styles.input}>
        <span className={styles.label}>натура</span>
        <span className={styles.value}>{isNaN(data.nature) ? '0' : +data?.nature}</span>
        <span className={styles.postfix}>г/л</span>
      </div>
    </>
  );
};
